import { z } from 'zod';

export const AnnotationTypeSchema = z.enum([
  'lidar_box',
  'sem_seg',
  'instance_seg',
  'lidar_seg',
  'video_event',
  'enrichment',
]);
export type AnnotationType = z.infer<typeof AnnotationTypeSchema>;

export const WorkflowKeySchema = z.enum([
  'lidar-box',
  'video-event',
  'enrichment',
]);
export type WorkflowKey = z.infer<typeof WorkflowKeySchema>;
